/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaIconEvent from 'DesignSystem/Svgs/TysiaIconEvent/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Topbar/PatientFlowActions/WaitingRoomAction/Content",
  onChange,
  onMouseEnter,
  onMouseLeave,
  hovered
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
let globalSidebarTogglesIsAgendaSidebarOpenValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'sidebar_toggles.is_agenda_sidebar_open',
})
let globalSidebarTogglesIsAgendaSidebarOpenChangeData = fromData.useDataChange({ viewPath,
context: 'global',
path: 'sidebar_toggles.is_agenda_sidebar_open',
formatOut: fromHelpers.not,
})
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<button
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 onClick={globalSidebarTogglesIsAgendaSidebarOpenChangeData}
 {...isHoveredBind}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--bc-1-Z1Yf8zk': hovered ? dtColorsNeutral700 : globalSidebarTogglesIsAgendaSidebarOpenValueData ? dtColorsNeutral700 : dtColorsNeutral800}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconEvent
  viewPath={`${viewPath}/TysiaIconEvent`}
 width={16}
 height={16}
 fill={dtColorsWhite}
/>
</button>
{children}
</React.Fragment>)
}